import type { Signalement } from "../domaine/types";

/**
 * - `chargement` : la source n'a pas répondu, ou pas avec le contenu attendu ;
 * - `validation` : la donnée est arrivée mais ne respecte pas le contrat.
 */
export type NatureErreurDonnees = "chargement" | "validation";

/**
 * Écart au contrat. Même forme qu'un `Signalement` : `table` est le fichier concerné,
 * `ligne` le numéro de ligne dans le fichier, en-tête compris (l'en-tête est la ligne 1).
 */
export type ProblemeDonnees = Signalement;

/**
 * Erreur de la couche d'accès aux données. Rien n'est corrigé en silence : une
 * donnée invalide arrête le chargement, avec la liste de ce qui ne va pas.
 */
export class ErreurDonnees extends Error {
  readonly nature: NatureErreurDonnees;
  readonly problemes: readonly ProblemeDonnees[];

  constructor(
    nature: NatureErreurDonnees,
    message: string,
    problemes: readonly ProblemeDonnees[] = [],
    options?: { cause?: unknown },
  ) {
    super(message, options);
    this.name = "ErreurDonnees";
    this.nature = nature;
    this.problemes = problemes;
  }
}

export function decrireProbleme(p: Signalement): string {
  const lieu = [p.table, p.ligne !== undefined ? `ligne ${p.ligne}` : null, p.colonne ?? null]
    .filter(Boolean)
    .join(" · ");
  return `${lieu} — ${p.message}`;
}
